module.exports = __webpack_public_path__ + "assets/img/ko-a3537470.png";